/**
 * Save function.
 *
 * We're maintaining frontend save data
 * from `/templates/blocks/text-generator/markup.php` file.
 */
export default function save() {
    return null;
}
